const Defaults = require('../util/defaults');
const EventEmitter = require('event-emitter');
const emitter = EventEmitter({});

const Modules = {
    AgeAdvisor: require('./../modules/age_advisor/age_advisor'),
    PauseScreen: require('./../modules/pause_screen/pause_screen'),
    RatingScreen: require('./../modules/rating_screen/rating_screen'),
    Controls: require('./../modules/controls/controls'),
    Subtitles: require('./../modules/subtitles_audio_track/subtitles_audio_track'),
    VideoQuality: require('./../modules/video_quality/video_quality'),
    Filmstrip: require('./../modules/filmstrip/filmstrip'),
    PlayerTitle: require('./../modules/player_title/player_title'),
    DeviceManager: require('./../modules/device_manager/device_manager').default,
    BackButton: require('./../modules/backbutton/back_button').default,
    Youbora: require('./../modules/report/youbora'),
    MediaList: require('../modules/media_list/media_list'),
    RecommendationEngine: require('../modules/recommendation_engine/recommendation_engine'),
    IdleControlsTracker: require('../modules/idle_controls_tracker/idle_controls_tracker').default,
    Preferences: require('../util/preferences_utils.js').default
};

module.exports = function(config, adapter, options) {

    return {
        onInit() {
            Modules.AgeAdvisor.showAgeScreen({
                ageRestriction: config.content.ageRestriction
            }, adapter.pause, adapter.play);
            Modules.Controls.init();
            Modules.BackButton.init(adapter);
        },

        onReady: function() {
            Modules.PlayerTitle.showTitle('Trailer - ' + (config.content.series.seriesName ? config.content.series.seriesName : config.content.title));
            adapter.startBuffering(adapter);
            setTimeout(() => adapter.seek(config.content.startAt), 100);
            const muted = Defaults.getValue('muted');
            if (muted) {
                adapter.mute();
            } else {
                const volumeLevel = Defaults.getValue('volume');
                if (volumeLevel <= 0) {
                    adapter.mute();
                } else {
                    const volumeLevel = Defaults.getValue('volume');
                    adapter.setVolume(volumeLevel);    
                }
            }
            setTimeout(() => Modules.Controls.initializeTooltipWrapper(), 200);
        },
        onPlaybackFinished: function() {
            adapter.exitFullscreen();
            if (options && options.clientHandlers !== undefined && typeof (options.clientHandlers.onPlaybackFinished) === 'function') {
                options.clientHandlers.onPlaybackFinished();
            }
        },

        onVolumeChange(volumeObj) {
            if (volumeObj.targetVolume < 1) {
                adapter.mute();
            }
        }
    };
};



// WEBPACK FOOTER //
// ./src/event_handlers/trailer.js